/**
 * Created by Moment on 2017/2/21.
 */

// 第三方状态常量
export const ThirdPartRefundStatusConst = {
  /**
   * 未处理
   */
  NOT_PROCESS: 1,

  /**
   * 等待退款处理
   */
  WAIT_PROCESS: 2,

  /**
   * 同意退款
   */
  ACCEPT: 4,

  /**
   * 退款完成
   */
  REFUND_COMPLETE: 32,

  /**
   * 退款取消
   */
  REFUND_CANCELED: 64,

  /**
   * 商家不同意
   */
  BUSINESS_NOT_ACCEPT: 256
}

// 第三方状态值对应的字面量对象
export const ThirdPartRefundStatusList = {
  /**
   * 未处理
   */
  '1': {
    text:'未处理',
    status:1
  },

  /**
   * 等待退款处理
   */
  '2': {
    text:'等待退款处理',
    status:2
  },

  /**
   * 同意退款
   */
  '4': {
    text:'同意退款',
    status:4
  },

  /**
   * 退款完成
   */
  '32': {
    text:'退款完成',
    status:32
  },

  /**
   * 退款取消
   */
  '64': {
    text:'退款取消',
    status:64
  },

  /**
   * 商家不同意
   */
  '256': {
    text:'商家不同意',
    status:256
  }
}
